
import { getItem } from '../../utils/localStorage';
import * as types from './auth.actionTypes';

const initialState = {
  userData: [],
  token: getItem('token') || '',
  isAuth: getItem('token') ? true : false,
  isLoading: false,
  isError: false,
  loginSuccess: false,
};

const initialSignupState = {
  isSigningUp: false,
  signUpError: null,
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.LOGIN_USER_REQUEST: {
      return {
        ...state,
        isLoading: true,
        isError: false,
        loginSuccess: false
      };
    }
    case types.LOGIN_USER_SUCCESS: {
      return {
        ...state,
        isAuth: true,
        isLoading: false,
        isError: false,
        loginSuccess: true
      };
    }
    case types.RESTORE_SESSION_SUCCESS: {
      // Silent re-auth on reload: mark authenticated without the
      // "successfully signed in" snackbar that loginSuccess triggers.
      return {
        ...state,
        isAuth: true,
        isLoading: false,
        isError: false,
        loginSuccess: false
      };
    }
    case types.LOGIN_USER_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isError: true,
        loginSuccess: false
      };
    }
    case types.LOGOUT_USER: {
      return {
        ...state,
        token: '',
        isAuth: false,
        loginSuccess: false
      };
    }
    default: {
      return state;
    }
  }
};

export const authReducer = (state = initialSignupState, action) => {
  switch (action.type) {
    case types.SIGN_UP_REQUEST:
      return { ...state, isSigningUp: true, signUpError: null };
    case types.SIGN_UP_SUCCESS:
      return { ...state, isSigningUp: false };
    case types.SIGN_UP_FAILURE:
      return { ...state, isSigningUp: false, signUpError: action.payload };
    default:
      return state;
  }
};